'use client';

import { Modal, Stack, Title } from '@mantine/core';
import { loginModalAtom } from '@website/atoms';
import { useAtom } from 'jotai/react';
import { useTranslations } from 'next-intl';
import { LoginForm } from './login/login-form';

export function LoginModal() {
  const t = useTranslations();
  const [opened, setOpened] = useAtom(loginModalAtom);

  return (
    <Modal opened={opened} onClose={() => setOpened(false)}>
      <Stack>
        <Title order={3}>{t('login.loginToYourAccount')}</Title>

        <LoginForm />
      </Stack>
    </Modal>
  );
}
